// Copy de la pantalla del paso 05 cuando la revisión del historial falla.
export const SCORE_CONSULT_ERROR_COPY = {
    title: 'Hubo un error al revisar el historial crediticio',
    text: 'No pudimos obtener el resultado. Intenta de nuevo o sigue la venta de contado, sin SureKeep.',
    retryLabel: 'Reintentar',
    cashLabel: 'Continuar sin SureKeep',
    cashHint: '«Continuar sin SureKeep» cambia la forma de pago a contado.',
} as const;
